import { matchPath } from "react-router";
import { Route, selectRoute } from "src/config/routes";
import { Role } from "src/network/User";

// A news is opened from a realestate or, without a realestate, from the page "News".
// Every route keeps the user where the news was opened from.

export const getNewsEditRoute = (newsid: string, realestateid: string | undefined, role?: Role) =>
    realestateid
        ? selectRoute(Route.realestateNewsEdit, role, { realestateid, newsid })
        : selectRoute(Route.newsEdit, role, { newsid });

export const getNewsPreviewRoute = (newsid: string, realestateid: string | undefined, role?: Role) =>
    realestateid
        ? selectRoute(Route.realestateNewsPreview, role, { realestateid, newsid })
        : selectRoute(Route.newsPreview, role, { newsid });

export const getNewsPreviewEditRoute = (newsid: string, realestateid: string | undefined, role?: Role) =>
    realestateid
        ? selectRoute(Route.realestateNewsPreviewEdit, role, { realestateid, newsid, newspreviewnewsid: newsid })
        : selectRoute(Route.newsPreviewEdit, role, { newsid, newspreviewnewsid: newsid });

// The dashboard of the realestate or the page "News".
export const getNewsOriginRoute = (realestateid: string | undefined, role?: Role) =>
    realestateid ? selectRoute(Route.dashboard, role, { realestateid }) : selectRoute(Route.newsOverview, role);

const NEWS_OVERVIEW_ROUTES = [Route.newsOverview, Route.newsEdit, Route.newsPreview, Route.newsPreviewEdit];

// The page "News" and the news opened from it. The sidebar marks "News" as active on all of them.
export const isNewsOverviewPathname = (pathname: string) =>
    matchPath(pathname, { path: NEWS_OVERVIEW_ROUTES.map((route) => Route.manager + route), exact: true }) !== null;
